import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [awbNumber, setAwbNumber] = useState(null);
    const [ticketId, setticketId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [refundType, setrefundType] = useState("");
    const openModal = (awbNumber, id,type) => {
        setAwbNumber(awbNumber);
        setticketId(id);
        setIsOpen(true);
        setrefundType(type)
    };

    const closeModal = () => {
        setIsOpen(false);
        setAwbNumber(null);
    };

    return (
        <ModalContext.Provider value={{ isOpen, awbNumber, openModal, closeModal, ticketId, modalOpen, setModalOpen ,refundType}}>
            {children}
        </ModalContext.Provider>
    );
};
